import {
  getChoiceList,
  getValueFromChoice,
  getValueFromChoiceProperties,
  getChoiceFromPropertyValue,
  isNumeric,
  isQCNotification,
  splitAndTrim,
} from '80.quickConnect.Core/helpers/common';
import {
  FieldDesc,
  AllFieldValueTypes,
  QCNotification,
  NotificationTarget,
  HierarchicalChoice,
  Choice,
  HierarchicalDesc,
} from '90.quickConnect.Models/models';
import { FieldType } from '90.quickConnect.Models/enums';
import { parseNumber } from '80.quickConnect.Core/helpers/parseNumber';
import { numericLocaleFormatLitteral } from '80.quickConnect.Core/helpers/numericLocaleFormatLitteral';
import { mapToNotificationDataFromHashMap } from '90.quickConnect.Models/mappings';

export const getReferencedHierarchicalListValue = (
  fieldWithReference: FieldDesc,
  valueReferenceDependency: AllFieldValueTypes,
  fieldTypeFieldWithReference: FieldType,
  columnId: string | undefined,
): AllFieldValueTypes => {
  const hierarchicalListValues = valueReferenceDependency as HierarchicalChoice | HierarchicalChoice[];
  const referencesProperties = columnId?.split(',');

  const { listChoice: listChoiceFromExp } = fieldWithReference as HierarchicalDesc;

  switch (fieldTypeFieldWithReference) {
    case FieldType.Text:
    case FieldType.Label:
    case FieldType.ReadOnlyValue:
      const result = getValueFromChoiceProperties(
        Array.isArray(hierarchicalListValues) ? hierarchicalListValues : [hierarchicalListValues],
        referencesProperties,
        true,
      ).join(', ');

      if (result === undefined || result === null) return undefined;

      if (typeof result === 'number') return numericLocaleFormatLitteral(result);

      return result;

    case FieldType.Notification:
      const { value } = fieldWithReference;
      const notificationValue = isQCNotification(value) ? value : mapToNotificationDataFromHashMap({});
      const res = getValueFromChoiceProperties(
        Array.isArray(hierarchicalListValues) ? hierarchicalListValues : [hierarchicalListValues],
        referencesProperties,
        true,
      );

      const resultNotification =
        splitAndTrim(res)
          /* eslint-disable-next-line no-useless-escape */
          .filter((item: string) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(item))
          .map((item: string) => ({ alias: null, target: item } as NotificationTarget)) ?? [];

      return {
        ...notificationValue,
        selectedTargets: resultNotification,
      };

    case FieldType.CheckBox:
      return hierarchicalListValues ? 1 : 0;

    case FieldType.Combo:
    case FieldType.CheckBoxList:
    case FieldType.HierarchicalList:
    case FieldType.RadioList:
    case FieldType.Alert:
      if (
        hierarchicalListValues === null ||
        (Array.isArray(hierarchicalListValues) && hierarchicalListValues.length === 0)
      )
        return [];
      if (
        referencesProperties &&
        referencesProperties.length > 0 &&
        referencesProperties[0] !== '' &&
        listChoiceFromExp
      ) {
        return getChoiceFromPropertyValue(
          hierarchicalListValues,
          referencesProperties,
          listChoiceFromExp,
          fieldWithReference,
          fieldTypeFieldWithReference,
        );
      }

      return getValueFromChoice(
        Array.isArray(hierarchicalListValues) ? hierarchicalListValues : [hierarchicalListValues],
        listChoiceFromExp,
        fieldTypeFieldWithReference,
      );

    case FieldType.Counter:
    case FieldType.Digits:
      return parseInt(
        getValueFromChoiceProperties(
          Array.isArray(hierarchicalListValues) ? hierarchicalListValues : [hierarchicalListValues],
          referencesProperties,
        ).join(', '),
      );

    case FieldType.Numeric:
    case FieldType.Slider:
      return parseNumber(
        getValueFromChoiceProperties(
          Array.isArray(hierarchicalListValues) ? hierarchicalListValues : [hierarchicalListValues],
          referencesProperties,
        ).join(', '),
      );

    default:
      return undefined;
  }
};
